import EventEmitter from './EventEmitter';
import GoogleAnalytics from './googleAnalytics';

class AuthorizedNavigation extends EventEmitter {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  init(isLogged) {
    this.isLogged = isLogged;

    if (typeof document !== 'undefined') {
      const reactRoot = document.getElementById('react');
      if (reactRoot) {
        reactRoot.addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  handleClick(event) {
    const { target } = event;
    const selector = '[data-blocked-link]';
    const parent = target.closest(selector);
    if (parent || target.matches(selector)) {
      const element = parent || target;

      if (element.dataset.enrollInfo) {
        const enrollInfo = JSON.parse(element.dataset.enrollInfo);
        GoogleAnalytics.enrollClicked(
          enrollInfo.event,
          enrollInfo.name,
          enrollInfo.source,
          enrollInfo.isLogged,
        );
      }

      const isBlocked = JSON.parse(element.dataset.blockedLink);

      if (isBlocked && !this.isLogged) {
        event.preventDefault();
        const redirectLink = element.getAttribute('href');
        this.emit(
          'blocked',
          /^(\/[a-z]{2})?\/signin$/i.test(redirectLink) ? '' : redirectLink,
        );
      }
    }
  }
}

const instance = new AuthorizedNavigation();
export default instance;
